import { api } from '@/api'
import { Period } from '@/ui-kit'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export function useFetchUserJobPoints(
  period: Period,
): UseQueryResult<Record<Period, Record<string, string>>> {
  return useQuery({
    queryKey: ['useFetchUserJobPoints', period],
    queryFn: () =>
      api.get(
        `/user/stats/job-points?period=${period}`
      ),
    retry: 0
  })
}
